<template>
  <div class="sheet-layout" v-loading="loading">
    <app-header
      v-if="app.template"
      :app="app"
      default-active="SheetList"
      @refresh="refreshApp"
    ></app-header>
    <side-menu
      :menu-list="menuForShow"
      :default-active="defaultMenu"
      :todo-visible="todoVisible"
      :group="menuGroup"
      :un-group="unGroup"
      @select="selectMenu"
      @setMenuPined="menuPined = $event"
      class="side-menu"
      @refreshMenu="refresh"
    ></side-menu>
    <section v-if="contentVisible" class="main-content" :class="{ 'not-pined': !menuPined }">
      <router-view ref="child"></router-view>
    </section>
  </div>
</template>

<script>
import SideMenu from "./SideMenu"
import { isAppAdmin } from "@/utils/checkPermission"
import AppHeader from "@/views/Front/Sheet/Layout/AppHeader"
import { getAppTemplate, getFrontSetting, setFrontSetting } from "@/api/user"
import { getSheetGroup } from "@/api/sheet/sheet"
import { todoGroup } from "@/views/Backend/Admin/Display/Menu/static"

export default {
  name: "sheet-layout",
  components: {
    AppHeader,
    SideMenu
  },
  provide() {
    return {
      app: this.app
    }
  },
  data() {
    return {
      todoGroup,
      defaultMenu: "",
      menuPined: true,
      menuGroup: [],
      unGroup: [],
      loading: false,
      app: {
        id: "",
        name: "-",
        template: Boolean(this.$route?.query?.template),
        templateInfo: { updateAt: null, status: null }
      },
      contentVisible: false,
      todoVisible: true,
      defaultItem: {}
    }
  },
  computed: {
    curAppId() {
      return this.$route.params.appId
    },
    // 展示的分组列表
    menuList() {
      return ((this.todoVisible ? [this.todoGroup] : []).concat(this.menuGroup) || [])
        .filter(group => (this._.keys(group).includes("visible") ? group.visible : true))
        .map(group => {
          return {
            label: group.name,
            value: group.id ? group.id : group.name,
            children: (group.itemList || [])
              .filter(item => (this._.keys(item).includes("visible") ? item.visible : true))
              .map(item => {
                return item.type === "GROUP"
                  ? {
                      label: item.name,
                      value: item.id,
                      type: item.type,
                      children: (item.itemList || [])
                        .filter(subItem =>
                          this._.keys(subItem).includes("visible") ? subItem.visible : true
                        )
                        .map(subItem => ({
                          label: subItem.name,
                          value: subItem.id,
                          icon: subItem.icon || "default-icon",
                          color: subItem.color || "#1989FA",
                          type: subItem.type,
                          url: subItem.type === "URL" ? subItem.url : "",
                          newTag: subItem.type === "URL" ? subItem.newTag : false
                        }))
                    }
                  : {
                      label: item.name,
                      value: item.id,
                      icon: item.icon || "default-icon",
                      color: item.color || "#1989FA",
                      type: item.type,
                      url: item.type === "URL" ? item.url : "",
                      newTag: item.type === "URL" ? item.newTag : false
                    }
              })
              .filter(item => (item.type === "GROUP" ? !this._.isEmpty(item.children) : true))
          }
        })
        .filter(group => !this._.isEmpty(group.children))
    },
    menuForShow() {
      return this.menuList
    },
    // 当前用户可访问的路径id
    accessRouteIds() {
      return this.menuList
        .filter(g => g.value !== "todo")
        .flatMap(g => g.children)
        .flatMap(g => {
          if (g.type === "GROUP") return g.children
          else return g
        })
        .map(t => t.value)
        .filter(t => t)
    },
    menuItemMap() {
      return this._.keyBy(
        this.menuForShow
          .flatMap(g => g.children)
          .flatMap(g => {
            if (g.type === "GROUP") return g.children
            else return g
          }),
        "value"
      )
    }
  },
  watch: {
    $route() {
      let keys = this._.keys(this.$route.params)
      if (
        this.$route.name !== "worksheet" ||
        (this.$route.name === "worksheet" && (!keys.includes("sheetId") || keys.includes("viewId")))
      )
        this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.contentVisible = false
      await this.refresh()
      this.dealRedirect()
      this.contentVisible = true
    },
    async refresh() {
      this.loading = true
      let cache = !this.app.template
      let app = await getAppTemplate(this.curAppId, cache)
      app.color = app.color ? app.color : "#1989fa"
      Object.assign(this.app, app)
      let frontSetting = await getFrontSetting(this.curAppId)
      let groupItem = await getSheetGroup(this.curAppId, cache)
      if (this._.keys(frontSetting).includes("defaultItem"))
        this.defaultItem = frontSetting["defaultItem"]
      if (
        this._.keys(frontSetting).includes("personalMenu") &&
        this._.keys(frontSetting["personalMenu"]).includes("groups")
      ) {
        this.todoVisible = frontSetting["personalMenu"].todoVisible
        this.menuGroup = this.getMenuGroups(
          frontSetting["personalMenu"]?.groups || [],
          groupItem?.groups || []
        )
        await this.$nextTick()
      } else {
        this.todoVisible = groupItem.todoVisible
        this.menuGroup = groupItem?.groups || []
      }
      this.loading = false
    },
    getMenuGroups(personGroups, appGroups) {
      let result = []
      let allPersonItemIds = personGroups
        .flatMap(g => g.itemList)
        .flatMap(g => {
          if (g.type === "GROUP") return g.itemList
          else return g
        })
        .map(item => item.id)
      let allAppItem = appGroups
        .flatMap(g => g.itemList)
        .flatMap(g => {
          if (g.type === "GROUP") return g.itemList
          else return g
        })
      let allItemIds = allAppItem.map(item => item.id)
      this.unGroup = allAppItem.filter(item => !allPersonItemIds.includes(item.id))
      result = personGroups.map(group => {
        group.itemList = group.itemList
          .filter(item => (item.type !== "GROUP" ? allItemIds.includes(item.id) : true))
          .map(item => {
            if (item.type !== "GROUP") return item
            else {
              item.itemList = item.itemList.filter(subItem =>
                subItem.type !== "GROUP" ? allItemIds.includes(subItem.id) : true
              )
              item.itemIdList = item.itemList.map(subItem => subItem.id)
              return item
            }
          })
        group.itemIdList = group.itemList.map(item => item.id)
        return group
      })
      return result
    },
    selectMenu(menuValue) {
      setFrontSetting(
        {
          id: menuValue
        },
        this.curAppId,
        "defaultItem"
      )
      let menuItem = this.menuItemMap[menuValue]
      const query = this.$route.query.boardFlag ? {} : this.$route.query
      switch (menuItem.type) {
        case "SHEET":
          this.$router.push({
            name: "worksheet",
            params: { appId: this.curAppId, sheetId: menuItem.value },
            query: query
          })
          break
        case "DASHBOARD":
          this.$router.push({
            name: "statistics-board",
            params: { appId: this.curAppId, boardId: menuItem.value },
            query: query
          })
          break
        case "TODO":
          this.$router.push({
            name: "todo-list",
            params: { appId: this.curAppId, id: menuItem.value },
            query: query
          })
          break
        case "METABASE":
          this.$router.push({
            name: "statistics-board-old",
            params: { appId: this.curAppId, boardId: menuItem.value },
            query: query
          })
          break
        case "URL":
          this.$router.push({
            name: "url",
            params: { appId: this.curAppId, id: menuItem.value, url: menuItem.url },
            query: query
          })
          break
      }
    },
    dealRedirect() {
      if (this._.isEmpty(this.menuList)) {
        if (isAppAdmin(this.curAppId)) {
          this.$message.error("请设置工作表及菜单列表")
          // 跳转到后台设置
          this.$router.push({
            name: "admin-menu-display",
            params: { appId: this.curAppId }
          })
        } else {
          this.$message.error("无权限查看此应用下的工作表,请联系应用管理员配置权限后访问")
          // 跳转首页
          this.$router.push({ name: "home" })
        }
        return
      }
      // 先提取个人设置中的路径，若无则取有权限的第一个id
      let curRouteId =
        this.$route.params.sheetId || this.$route.params.boardId || this.$route.params.id
      let routeId
      if (this.accessRouteIds.includes(curRouteId)) {
        routeId = curRouteId
      } else {
        let defaultRouteId = ""
        if (!this._.isEmpty(this.defaultItem)) {
          defaultRouteId = this.defaultItem.id
          if (
            !this.accessRouteIds.includes(defaultRouteId) &&
            !["verify", "favorite"].includes(defaultRouteId)
          ) {
            defaultRouteId = this.accessRouteIds[0]
          }
        } else {
          defaultRouteId = this.accessRouteIds[0]
        }
        routeId = defaultRouteId
      }
      this.defaultMenu = routeId
      if (curRouteId !== routeId) {
        let menuItem = this.menuItemMap[routeId]
        switch (menuItem.type) {
          case "SHEET":
            this.$router.replace({
              name: "worksheet",
              params: { appId: this.curAppId, sheetId: menuItem.value },
              query: this.$route.query
            })
            break
          case "DASHBOARD":
            this.$router.replace({
              name: "statistics-board",
              params: { appId: this.curAppId, boardId: menuItem.value },
              query: this.$route.query
            })
            break
          case "TODO":
            this.$router.replace({
              name: "todo-list",
              params: { appId: this.curAppId, id: menuItem.value },
              query: this.$route.query
            })
            break
          case "METABASE":
            this.$router.replace({
              name: "statistics-board-old",
              params: { appId: this.curAppId, boardId: menuItem.value },
              query: this.$route.query
            })
            break
          case "URL":
            this.$router.replace({
              name: "url",
              params: { appId: this.curAppId, id: menuItem.value, url: menuItem.url },
              query: this.$route.query
            })
            break
        }
      }
    },
    refreshApp() {
      getAppTemplate(this.curAppId).then(app => Object.assign(this.app, app))
    }
  }
}
</script>

<style lang="scss" scoped>
.sheet-layout {
  width: 100%;
  height: 100%;
  .side-menu {
    position: absolute;
    left: 0;
    top: 0;
    width: 240px;
    height: 100%;
    z-index: 2;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(33, 43, 54, 0.1);
    color: #2a304d;
  }
  .main-content {
    background: #ffffff;
    position: relative;
    height: 100%;
    margin-left: 240px;
    overflow: hidden;
    z-index: 1;
    &.not-pined {
      margin-left: 52px;
    }
    ::v-deep {
      .top-wrap {
        display: flex;
        align-items: center;
        padding: 16px 16px 8px;
        .main-title {
          font-size: 18px;
          line-height: 18px;
          font-weight: bold;
          margin-right: auto;
        }
        .right {
          display: flex;
        }
      }
      .main-wrap {
        position: absolute;
        top: 56px;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
